import EventDetailHome from '@/screens/EventDetailHome';

export default function PrivateTabsOrganizationEventEventIdIndexRoute() {
  return (
    <EventDetailHome
      basePath="/organization/event/[eventId]"
      teamMemberPathname="/organization/event/team/member/[personId]"
    />
  );
}
